var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsAutomationsProcessorsStopAutomation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bubvrs29ka",
    d: "M26.662 1.103l20.235 20.235c1.47 1.47 1.47 3.854 0 5.324L26.662 46.897c-1.47 1.47-3.854 1.47-5.324 0L1.103 26.662c-1.47-1.47-1.47-3.854 0-5.324L21.338 1.103c1.47-1.47 3.854-1.47 5.324 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "haawrqtz5b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bubvrs29ka"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#0D0D0D",
    className: "background",
    xlinkHref: "#bubvrs29ka"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#haawrqtz5b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.154 6c1.337 0 1.822.14 2.311.4.49.262.873.646 1.134 1.135.262.489.401.974.401 2.31v12.31c0 1.336-.14 1.821-.4 2.31-.262.49-.646.873-1.135 1.134-.489.262-.974.401-2.31.401H9.844c-1.336 0-1.821-.14-2.31-.4-.49-.262-.873-.646-1.134-1.135-.262-.489-.401-.974-.401-2.31V9.844c0-1.336.14-1.821.4-2.31.262-.49.646-.873 1.135-1.134.489-.262.974-.401 2.31-.401h12.31zM24 8H8v16h16V8z",
    transform: "translate(8 8)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsAutomationsProcessorsStopAutomation);
export default __webpack_public_path__ + "static/media/illustrations-automations-processors-stop-automation.ac651637.svg";
export { ForwardRef as ReactComponent };